import { IModelDataV1, Model } from '@df/catalog/model';

export interface IRating {
    rating: number;
    count: number;
}

export interface IReviewData extends IModelDataV1<number>, IRating {
    author?: string;
    date?: string;
    title?: string;
    content?: string;
    replies?: { message: string }[];
}

/**
 * Review model representing magento review
 */
export class Review extends Model<IReviewData> {
    /**
     * Object type id
     * @type {String}
     */
    static override type = 'review';
}
